// ../../../../../../../../../private/var/folders/wt/3dgdj74n149c829y3v7zk6qh0000gn/T/oat-shopify-m1g4finc/data.mjs
var products = [
  { id: "chocolate", pct: ["61%", "23%", "7%", "7%", "1%", null], name: "Chocolate", kind: "Original", sachets: 12, color: "#C16A23", dark: "#843E1E", paper: "#EFDBC5", image: "oatmazing-pack-chocolate-studio-2026-10-06.jpg", hook: "61% organic oats. No creamer, zero junk fillers.", description: "Organic oats with cocoa, soy and a little chia. Buyers call it smooth and not too sweet.", ingredients: ["Organic oat flakes", "Organic cane sugar", "Organic cocoa powder", "Organic soy powder", "Organic chia seeds", "Himalayan rock salt"], note: "Contains soy. This Original recipe includes organic cane sugar.", art: "v05", elements: ["e01-oat-flakes", "e08-cane-sugar", "e03-cocoa-powder", "e05-soy-powder", "e02-chia-seeds", "e09-rock-salt"], oat: "61%" },
  { id: "blueberry", pct: ["61%", "23%", "15%", "0.8%", null], name: "Blueberry Chia", kind: "Original", sachets: 12, color: "#745FAA", dark: "#3D256C", paper: "#E1DAEB", image: "oatmazing-pack-blueberry-chia-studio-2026-10-06.jpg", hook: "61% organic oats. No creamer, zero junk fillers.", description: "Organic blueberry powder and oat flakes, with tiny chia seeds in every mug.", ingredients: ["Organic oat flakes", "Organic blueberry powder", "Organic cane sugar", "Organic chia seeds", "Himalayan rock salt"], note: "This Original recipe includes organic cane sugar. Blueberry is included as powder. Check the current pack for the full allergen statement.", art: "v07", elements: ["e01-oat-flakes", "e04-blueberry-powder", "e08-cane-sugar", "e02-chia-seeds", "e09-rock-salt"], oat: "61%" },
  { id: "soy", pct: ["54%", "28%", "15%", "3%", null, "0.1%"], name: "Soy Almond Nibs", kind: "Original", sachets: 12, color: "#FBAE2E", dark: "#924C0D", paper: "#F4E5C5", image: "oatmazing-pack-soy-almond-nibs-studio-2026-10-06.jpg", hook: "54% organic oats. No creamer, zero junk fillers.", description: "Organic oats and soy powder, with almond pieces you can taste.", ingredients: ["Organic oat flakes", "Organic soy powder", "Organic cane sugar", "Almond nibs", "Himalayan rock salt", "Organic chia seeds"], note: "Contains soy and almond. This Original recipe includes organic cane sugar.", art: "v10", elements: ["e01-oat-flakes", "e05-soy-powder", "e08-cane-sugar", "e06-almond-nibs", "e09-rock-salt", "e02-chia-seeds"], oat: "54%" },
  { id: "rice", pct: ["63%", "17%", "14%", "3%", null, "1%", null], name: "Brown Rice", kind: "Zero Added Sugar", sachets: 11, color: "#5CBB47", dark: "#226B32", paper: "#E7EBCF", image: "oatmazing-pack-brown-rice-zas-studio-2026-10-06.jpg", hook: "63% organic oats. No creamer, no added sugar.", description: "Oats and brown rice powder, with roasted almond nibs and a little vanilla. No cane sugar added.", ingredients: ["Organic quick rolled oat", "Organic brown rice powder", "Organic soy powder", "Roasted almond nibs", "Vanilla powder", "Organic chia seeds", "Himalayan rock salt"], note: "Contains soy and almond. No added cane sugar in this recipe. It still contains naturally occurring sugars.", art: "v03", elements: ["e01-oat-flakes", "e07-brown-rice-powder", "e05-soy-powder", "e06-almond-nibs", "e10-vanilla-powder", "e02-chia-seeds", "e09-rock-salt"], oat: "63%" },
  { id: "soy-zas", pct: ["62%", "34%", "3%", "1%", null], name: "Soy Almond Nibs", kind: "Zero Added Sugar", sachets: 11, color: "#F47727", dark: "#95400C", paper: "#F5E5D3", image: "oatmazing-pack-soy-almond-nibs-zas-studio-2026-10-06.jpg", hook: "62% organic oats. No creamer, no added sugar.", description: "Oats, soy and almond nibs, with no cane sugar added.", ingredients: ["Organic quick rolled oat", "Organic soy powder", "Almond nibs", "Organic chia seeds", "Himalayan rock salt"], note: "Contains soy and almond. Zero Added Sugar does not mean sugar-free.", art: "v12", elements: ["e01-oat-flakes", "e05-soy-powder", "e06-almond-nibs", "e02-chia-seeds", "e09-rock-salt"], oat: "62%" }
];
var productsZh = {
  chocolate: { name: "\u5DE7\u514B\u529B", kind: "\u7ECF\u5178", hook: "61%\u6709\u673A\u71D5\u9EA6\u3002\u4E0D\u542B\u5976\u7CBE\uFF0C\u96F6\u5783\u573E\u586B\u5145\u7269\u3002", description: "\u6709\u673A\u71D5\u9EA6\u52A0\u53EF\u53EF\u7C89\u3001\u9EC4\u8C46\u7C89\u548C\u5C11\u8BB8\u5947\u4E9A\u7C7D\u3002\u4E70\u5BB6\u8BF4\u5B83\u987A\u6ED1\u3001\u4E0D\u4F1A\u592A\u751C\u3002", ingredients: ["\u6709\u673A\u71D5\u9EA6\u7247", "\u6709\u673A\u8517\u7CD6", "\u6709\u673A\u53EF\u53EF\u7C89", "\u6709\u673A\u9EC4\u8C46\u7C89", "\u6709\u673A\u5947\u4E9A\u7C7D", "\u559C\u9A6C\u62C9\u96C5\u5CA9\u76D0"], note: "\u542B\u9EC4\u8C46\u3002\u8FD9\u6B3E\u7ECF\u5178\u53E3\u5473\u542B\u6709\u673A\u8517\u7CD6\u3002" },
  blueberry: { name: "\u84DD\u8393\u5947\u4E9A\u7C7D", kind: "\u7ECF\u5178", hook: "61%\u6709\u673A\u71D5\u9EA6\u3002\u4E0D\u542B\u5976\u7CBE\uFF0C\u96F6\u5783\u573E\u586B\u5145\u7269\u3002", description: "\u6709\u673A\u84DD\u8393\u7C89\u914D\u71D5\u9EA6\u7247\uFF0C\u6BCF\u4E00\u676F\u90FD\u6709\u5C0F\u5C0F\u7684\u5947\u4E9A\u7C7D\u3002", ingredients: ["\u6709\u673A\u71D5\u9EA6\u7247", "\u6709\u673A\u84DD\u8393\u7C89", "\u6709\u673A\u8517\u7CD6", "\u6709\u673A\u5947\u4E9A\u7C7D", "\u559C\u9A6C\u62C9\u96C5\u5CA9\u76D0"], note: "\u8FD9\u6B3E\u7ECF\u5178\u53E3\u5473\u542B\u6709\u673A\u8517\u7CD6\u3002\u84DD\u8393\u662F\u4EE5\u7C89\u72B6\u52A0\u5165\u3002\u5B8C\u6574\u7684\u8FC7\u654F\u539F\u8BF4\u660E\u8BF7\u770B\u6700\u65B0\u5305\u88C5\u3002" },
  soy: { name: "\u9EC4\u8C46\u674F\u4EC1\u788E", kind: "\u7ECF\u5178", hook: "54%\u6709\u673A\u71D5\u9EA6\u3002\u4E0D\u542B\u5976\u7CBE\uFF0C\u96F6\u5783\u573E\u586B\u5145\u7269\u3002", description: "\u6709\u673A\u71D5\u9EA6\u548C\u9EC4\u8C46\u7C89\uFF0C\u52A0\u4E0A\u5403\u5F97\u5230\u7684\u674F\u4EC1\u788E\u3002", ingredients: ["\u6709\u673A\u71D5\u9EA6\u7247", "\u6709\u673A\u9EC4\u8C46\u7C89", "\u6709\u673A\u8517\u7CD6", "\u674F\u4EC1\u788E", "\u559C\u9A6C\u62C9\u96C5\u5CA9\u76D0", "\u6709\u673A\u5947\u4E9A\u7C7D"], note: "\u542B\u9EC4\u8C46\u548C\u674F\u4EC1\u3002\u8FD9\u6B3E\u7ECF\u5178\u53E3\u5473\u542B\u6709\u673A\u8517\u7CD6\u3002" },
  rice: { name: "\u7CD9\u7C73", kind: "\u65E0\u6DFB\u52A0\u7CD6", hook: "63%\u6709\u673A\u71D5\u9EA6\u3002\u4E0D\u542B\u5976\u7CBE\uFF0C\u65E0\u6DFB\u52A0\u7CD6\u3002", description: "\u71D5\u9EA6\u548C\u7CD9\u7C73\u7C89\uFF0C\u52A0\u70E4\u674F\u4EC1\u788E\u548C\u4E00\u70B9\u9999\u8349\u7C89\u3002\u6CA1\u6709\u6DFB\u52A0\u8517\u7CD6\u3002", ingredients: ["\u6709\u673A\u5373\u98DF\u71D5\u9EA6\u7247", "\u6709\u673A\u7CD9\u7C73\u7C89", "\u6709\u673A\u9EC4\u8C46\u7C89", "\u70E4\u674F\u4EC1\u788E", "\u9999\u8349\u7C89", "\u6709\u673A\u5947\u4E9A\u7C7D", "\u559C\u9A6C\u62C9\u96C5\u5CA9\u76D0"], note: "\u542B\u9EC4\u8C46\u548C\u674F\u4EC1\u3002\u8FD9\u6B3E\u6CA1\u6709\u6DFB\u52A0\u8517\u7CD6\uFF0C\u4F46\u4ECD\u542B\u5929\u7136\u5B58\u5728\u7684\u7CD6\u3002" },
  "soy-zas": { name: "\u9EC4\u8C46\u674F\u4EC1\u788E", kind: "\u65E0\u6DFB\u52A0\u7CD6", hook: "62%\u6709\u673A\u71D5\u9EA6\u3002\u4E0D\u542B\u5976\u7CBE\uFF0C\u65E0\u6DFB\u52A0\u7CD6\u3002", description: "\u71D5\u9EA6\u3001\u9EC4\u8C46\u548C\u674F\u4EC1\u788E\uFF0C\u6CA1\u6709\u6DFB\u52A0\u8517\u7CD6\u3002", ingredients: ["\u6709\u673A\u5373\u98DF\u71D5\u9EA6\u7247", "\u6709\u673A\u9EC4\u8C46\u7C89", "\u674F\u4EC1\u788E", "\u6709\u673A\u5947\u4E9A\u7C7D", "\u559C\u9A6C\u62C9\u96C5\u5CA9\u76D0"], note: "\u542B\u9EC4\u8C46\u548C\u674F\u4EC1\u3002\u65E0\u6DFB\u52A0\u7CD6\u4E0D\u7B49\u4E8E\u65E0\u7CD6\u3002" }
};
var elementsZh = { "e01-oat-flakes": "\u71D5\u9EA6\u7247", "e02-chia-seeds": "\u5947\u4E9A\u7C7D", "e03-cocoa-powder": "\u53EF\u53EF\u7C89", "e04-blueberry-powder": "\u84DD\u8393\u7C89", "e05-soy-powder": "\u9EC4\u8C46\u7C89", "e06-almond-nibs": "\u674F\u4EC1\u788E", "e07-brown-rice-powder": "\u7CD9\u7C73\u7C89", "e08-cane-sugar": "\u8517\u7CD6", "e09-rock-salt": "\u559C\u9A6C\u62C9\u96C5\u5CA9\u76D0", "e10-vanilla-powder": "\u9999\u8349\u7C89", "e11-oat-botanical": "\u71D5\u9EA6\u690D\u7269", "e12-mug-ritual": "\u6696\u676F\u65F6\u5149" };
var elements = [
  ["e01-oat-flakes", "Oat flakes", "The flattened flakes at the heart of all five recipes."],
  ["e02-chia-seeds", "Chia seeds", "Tiny mottled seeds. A small part of every recipe."],
  ["e03-cocoa-powder", "Cocoa powder", "The cocoa ingredient in Chocolate."],
  ["e04-blueberry-powder", "Blueberry powder", "Blueberry Chia uses fruit powder, not whole berries."],
  ["e05-soy-powder", "Soy powder", "A powder ingredient in all recipes except Blueberry Chia."],
  ["e06-almond-nibs", "Almond nibs", "Small almond pieces; the Brown Rice recipe uses roasted nibs."],
  ["e07-brown-rice-powder", "Brown rice powder", "The rice ingredient in Brown Rice Zero Added Sugar."],
  ["e08-cane-sugar", "Cane sugar", "Included in the three Original recipes."],
  ["e09-rock-salt", "Himalayan rock salt", "A small ingredient across all five recipes."],
  ["e10-vanilla-powder", "Vanilla powder", "Listed in the Brown Rice recipe."],
  ["e11-oat-botanical", "The oat plant", "A botanical origin cue, rather than an added ingredient."],
  ["e12-mug-ritual", "The warm-mug ritual", "An everyday occasion, brought into the same visual language."]
];

// ../../../../../../../../../private/var/folders/wt/3dgdj74n149c829y3v7zk6qh0000gn/T/oat-shopify-m1g4finc/strings.mjs
var plural = (n, one, many) => n === 1 ? one : many;
var EN = {
  lang: "en",
  name: (p) => p.name,
  kind: (p) => p.kind,
  hook: (p) => p.hook,
  description: (p) => p.description,
  ingredients: (p) => p.ingredients,
  note: (p) => p.note,
  element: (id) => elements.find((row) => row[0] === id)[1],
  label: (p) => `${p.name}${p.kind === "Zero Added Sugar" ? " Zero Added Sugar" : ""}`,
  packAlt: (p) => `${p.name} ${p.kind} pack`,
  format: (p) => `${p.sachets} sachets \xD7 28g \xB7 ${p.kind}`,
  recipeFormat: (p) => `${p.sachets} sachets \xD7 28g \xB7 RM36.99 per pack`,
  packWord: (n) => plural(n, "pack", "packs"),
  nextMessage: (left, next) => `Add ${left} more ${plural(left, "pack", "packs")} to unlock ${next === 4 ? "1 free pack (save RM36.99) + free delivery" : "2 free packs (save RM73.98)"}.`,
  fullMessage: "2 free packs + free delivery unlocked. Your bundle is at its best price.",
  afterMessage: "1 free pack + free delivery unlocked.",
  startMessage: "Add 4 packs to get 1 free (save RM36.99) + free delivery.",
  freeLabel: (n) => n ? `${n} free ${plural(n, "pack", "packs")}` : "Free packs",
  deliveryFree: "FREE",
  deliveryLocked: "RM10 \xB7 free from 4 packs",
  unitPrice: (price, saved) => `${price} per pack${saved ? " with your savings" : ""}.`,
  unitStart: "RM36.99 per pack before bundle savings.",
  dockCount: (n) => `${n} ${plural(n, "pack", "packs")} picked`,
  dockMessage: (free, left) => free ? `${free} free ${plural(free, "pack", "packs")} + free delivery` : left ? `${left} more for a free pack` : "Build your bundle",
  progressText: (n, free) => `${n} packs selected; ${free} free packs unlocked`,
  slotFree: ", free pack",
  slotEmpty: (i) => `Empty pack slot ${i}`,
  status: (n, free, total, message) => `${n} packs selected. ${free} free. Total ${total}. ${message}`,
  unlockToast: (m) => m === 4 ? "1 free pack + free delivery unlocked!" : "2 free packs + free delivery unlocked!",
  fullToast: "Your 7-pack bundle is full. Remove a pack to swap a flavour.",
  addedToast: (p) => `${p.name} added to your bundle.`,
  countdown: (l) => `${l.days * 24 + l.hours}h ${String(l.minutes).padStart(2, "0")}m`,
  // the 48 h hold reads as hours
  orderKind: (p) => `${p.kind} \xB7 ${p.sachets} sachets per pack`,
  orderDelivery: (free, sub, pct, freeDelivery) => `${free ? `${free} free ${plural(free, "pack", "packs")} included. ` : ""}${sub ? `Subscribe & save ${pct}%: delivered every month, skip or cancel anytime. ` : ""}${freeDelivery ? "Free delivery unlocked." : "Delivery is worked out at checkout."} 30-day money-back guarantee on your first order.`,
  pause: "Pause",
  play: "Play",
  finder: { classic: [["chocolate", "Chocolatey"], ["blueberry", "Fruity"], ["soy", "Nutty"]], zas: [["soy-zas", "Nutty"], ["rice", "Toasty brown rice"]] },
  finderResult: (p) => `Try ${p.name}${p.kind === "Zero Added Sugar" ? " Zero Added Sugar" : ""}. It\u2019s open below.`,
  reelPause: "Pause the morning slideshow",
  reelPlay: "Play the morning slideshow",
  reelScene: (i, n) => `Scene ${i} of ${n}`
};
var zh = (p) => productsZh[p.id];
var ZH = {
  lang: "zh",
  name: (p) => zh(p).name,
  kind: (p) => zh(p).kind,
  hook: (p) => zh(p).hook,
  description: (p) => zh(p).description,
  ingredients: (p) => zh(p).ingredients,
  note: (p) => zh(p).note,
  element: (id) => elementsZh[id],
  label: (p) => `${zh(p).name}${p.kind === "Zero Added Sugar" ? "\uFF08\u65E0\u6DFB\u52A0\u7CD6\uFF09" : ""}`,
  packAlt: (p) => `${zh(p).name}${p.kind === "Zero Added Sugar" ? "\uFF08\u65E0\u6DFB\u52A0\u7CD6\uFF09" : ""}\u5305\u88C5`,
  format: (p) => `${p.sachets}\u5C0F\u5305 \xD7 28\u514B \xB7 ${zh(p).kind}`,
  recipeFormat: (p) => `${p.sachets}\u5C0F\u5305 \xD7 28\u514B \xB7 \u6BCF\u5305RM36.99`,
  packWord: () => "\u5305",
  nextMessage: (left, next) => `\u518D\u52A0${left}\u5305\uFF0C\u5C31\u80FD\u62FF${next === 4 ? "1\u5305\u514D\u8D39\uFF08\u7701RM36.99\uFF09+ \u514D\u8FD0\u8D39" : "2\u5305\u514D\u8D39\uFF08\u7701RM73.98\uFF09"}\u3002`,
  fullMessage: "\u5DF2\u62FF\u52302\u5305\u514D\u8D39 + \u514D\u8FD0\u8D39\u3002\u8FD9\u662F\u6700\u5212\u7B97\u7684\u7EC4\u5408\u3002",
  afterMessage: "\u5DF2\u62FF\u52301\u5305\u514D\u8D39 + \u514D\u8FD0\u8D39\u3002",
  startMessage: "\u9009\u6EE14\u5305\uFF0C\u90011\u5305\uFF08\u7701RM36.99\uFF09+ \u514D\u8FD0\u8D39\u3002",
  freeLabel: (n) => n ? `\u514D\u8D39${n}\u5305` : "\u514D\u8D39\u7684\u5305",
  deliveryFree: "\u514D\u8FD0\u8D39",
  deliveryLocked: "RM10\uFF0C\u6EE14\u5305\u514D\u8FD0\u8D39",
  unitPrice: (price, saved) => `${saved ? "\u4F18\u60E0\u540E" : ""}\u6BCF\u5305${price}\u3002`,
  unitStart: "\u7EC4\u5408\u4F18\u60E0\u524D\uFF0C\u6BCF\u5305RM36.99\u3002",
  dockCount: (n) => `\u5DF2\u9009${n}\u5305`,
  dockMessage: (free, left) => free ? `\u514D\u8D39${free}\u5305 + \u514D\u8FD0\u8D39` : left ? `\u518D\u52A0${left}\u5305\u5C31\u90011\u5305` : "\u9009\u8D2D\u4F60\u7684\u7EC4\u5408",
  progressText: (n, free) => `\u5DF2\u9009${n}\u5305\uFF0C\u5176\u4E2D\u514D\u8D39${free}\u5305`,
  slotFree: "\uFF0C\u514D\u8D39",
  slotEmpty: (i) => `\u7B2C${i}\u4E2A\u7A7A\u4F4D`,
  status: (n, free, total, message) => `\u5DF2\u9009${n}\u5305\uFF0C\u514D\u8D39${free}\u5305\uFF0C\u603B\u4EF7${total}\u3002${message}`,
  unlockToast: (m) => m === 4 ? "\u5DF2\u62FF\u52301\u5305\u514D\u8D39 + \u514D\u8FD0\u8D39\uFF01" : "\u5DF2\u62FF\u52302\u5305\u514D\u8D39 + \u514D\u8FD0\u8D39\uFF01",
  fullToast: "\u4F60\u76847\u5305\u7EC4\u5408\u5DF2\u7ECF\u6EE1\u4E86\u3002\u5148\u51CF\u4E00\u5305\uFF0C\u624D\u80FD\u6362\u53E3\u5473\u3002",
  addedToast: (p) => `\u5DF2\u628A${zh(p).name}\u52A0\u8FDB\u4F60\u7684\u7EC4\u5408\u3002`,
  countdown: (l) => `${l.days * 24 + l.hours}\u5C0F\u65F6 ${String(l.minutes).padStart(2, "0")}\u5206`,
  orderKind: (p) => `${zh(p).kind} \xB7 \u6BCF\u5305${p.sachets}\u5C0F\u5305`,
  orderDelivery: (free, sub, pct, freeDelivery) => `${free ? `\u5305\u542B\u514D\u8D39\u7684${free}\u5305\u3002` : ""}${sub ? `\u8BA2\u9605\u7701${pct}%\uFF1A\u6BCF\u6708\u9001\u5230\uFF0C\u968F\u65F6\u53EF\u4EE5\u8DF3\u8FC7\u6216\u53D6\u6D88\u3002` : ""}${freeDelivery ? "\u5DF2\u514D\u8FD0\u8D39\u3002" : "\u8FD0\u8D39\u5728\u7ED3\u8D26\u65F6\u8BA1\u7B97\u3002"}\u9996\u6B21\u8BA2\u8D2D\uFF0C30\u5929\u5185\u4E0D\u6EE1\u610F\u53EF\u9000\u6B3E\u3002`,
  pause: "\u6682\u505C",
  play: "\u64AD\u653E",
  finder: { classic: [["chocolate", "\u5DE7\u514B\u529B\u5473"], ["blueberry", "\u679C\u9999\u5473"], ["soy", "\u575A\u679C\u9999"]], zas: [["soy-zas", "\u575A\u679C\u9999"], ["rice", "\u70E4\u7CD9\u7C73\u9999"]] },
  finderResult: (p) => `\u8BD5\u8BD5${zh(p).name}${p.kind === "Zero Added Sugar" ? "\uFF08\u65E0\u6DFB\u52A0\u7CD6\uFF09" : ""}\uFF0C\u5DF2\u7ECF\u5728\u4E0B\u9762\u5E2E\u4F60\u6253\u5F00\u4E86\u3002`,
  reelPause: "\u6682\u505C\u753B\u9762\u64AD\u653E",
  reelPlay: "\u7EE7\u7EED\u64AD\u653E\u753B\u9762",
  reelScene: (i, n) => `\u7B2C${i}\u4E2A\u753B\u9762\uFF0C\u5171${n}\u4E2A`
};
var strings = (lang) => lang.startsWith("zh") ? ZH : EN;
var productsById = Object.fromEntries(products.map((p) => [p.id, p]));

// ../../../../../../../../../private/var/folders/wt/3dgdj74n149c829y3v7zk6qh0000gn/T/oat-shopify-m1g4finc/bundle-core.mjs
var UNIT_CENTS = 3699;
var MAX_PACKS = 7;
var IDS = ["rice", "chocolate", "blueberry", "soy", "soy-zas"];
var money = (cents) => `RM${(cents / 100).toFixed(2)}`;
function normaliseBasket(raw) {
  const basket2 = Object.fromEntries(IDS.map((id) => [id, 0]));
  let available = MAX_PACKS;
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return basket2;
  for (const id of IDS) {
    const value = raw[id];
    if (!Number.isSafeInteger(value) || value < 0) continue;
    basket2[id] = Math.min(value, available);
    available -= basket2[id];
  }
  return basket2;
}
function totals(raw, now = Date.now()) {
  const basket2 = normaliseBasket(raw);
  const count = Object.values(basket2).reduce((a, b) => a + b, 0);
  const launch = offerLive(now);
  const free = count >= 7 && launch ? 2 : count >= 4 ? 1 : 0;
  const paid = count - free;
  return { basket: basket2, count, free, paid, retail: count * UNIT_CENTS, savings: free * UNIT_CENTS, total: paid * UNIT_CENTS, freeDelivery: count >= 4, launch, next: count < 4 ? 4 : count < 7 && launch ? 7 : null };
}
function changeQuantity(raw, id, delta) {
  const state = totals(raw);
  if (!IDS.includes(id) || ![1, -1].includes(delta)) return state.basket;
  if (delta === 1 && state.count === MAX_PACKS) return state.basket;
  return { ...state.basket, [id]: Math.max(0, state.basket[id] + delta) };
}
var SUBSCRIBE_PCT = 10;
var subscribedTotal = (cents) => Math.round(cents * (100 - SUBSCRIBE_PCT) / 100);
var HOLD_HOURS = 48;
var holdEndsAt = (firstMs, nowMs = firstMs) => {
  const h = HOLD_HOURS * 36e5;
  return new Date(firstMs + (Math.floor(Math.max(0, nowMs - firstMs) / h) + 1) * h).toISOString();
};
var ACTIVE_END = holdEndsAt(Date.now());
var setOfferEnd = (iso) => {
  if (Number.isFinite(Date.parse(iso))) ACTIVE_END = iso;
};
var offerLive = () => true;
function offerRemaining(nowMs, endsAt = ACTIVE_END) {
  const ms = Date.parse(endsAt) - nowMs;
  if (!(ms > 0)) return null;
  const m = Math.floor(ms / 6e4);
  return { days: Math.floor(m / 1440), hours: Math.floor(m % 1440 / 60), minutes: m % 60 };
}

// ../../../../../../../../../private/var/folders/wt/3dgdj74n149c829y3v7zk6qh0000gn/T/oat-shopify-m1g4finc/app.mjs
var firstVisit = NaN;
try {
  firstVisit = Number(localStorage.getItem("oatmazing:first-visit"));
  if (!(firstVisit > 0)) {
    firstVisit = Date.now();
    localStorage.setItem("oatmazing:first-visit", String(firstVisit));
  }
} catch {
  firstVisit = Date.now();
}
setOfferEnd(holdEndsAt(firstVisit, Date.now()));
var S = strings(document.documentElement.lang || "en");
var $ = (selector) => document.querySelector(selector);
var $$ = (selector) => [...document.querySelectorAll(selector)];
var text = (selector, value) => $$(selector).forEach((node) => {
  node.textContent = value;
});
var reduced = matchMedia("(prefers-reduced-motion: reduce)");
var storageKey = "oatmazing:earth-city:bundle:v6";
var track = (event, detail = {}) => document.dispatchEvent(new CustomEvent("loveearth:interaction", { detail: { event, range: "nutri-oat-mazing", ...detail } }));
var basket = normaliseBasket(null);
var active = products[0];
var recipe = products[0];
var toastTimer;
var lastFocus;
try {
  basket = normaliseBasket(JSON.parse(localStorage.getItem(storageKey)));
} catch {
}
var buyType = "once";
try {
  if (localStorage.getItem("oatmazing:buy-type") === "sub") buyType = "sub";
} catch {
}
var payable = (state) => buyType === "sub" ? subscribedTotal(state.total) : state.total;
function toast(message) {
  const node = $(".toast");
  node.textContent = message;
  node.hidden = false;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    node.hidden = true;
  }, 2800);
}
function ingredientFigure(id) {
  const [file] = elements.find((row) => row[0] === id), label = S.element(id);
  const figure = document.createElement("figure"), img = document.createElement("img"), caption = document.createElement("figcaption");
  img.src = `${window.OAT_ASSET_BASE}${file}.webp`;
  img.alt = "";
  img.width = 110;
  img.height = 100;
  caption.textContent = label;
  figure.append(img, caption);
  return figure;
}
function packPhoto(product, alt = "") {
  const frame2 = document.createElement("span"), img = document.createElement("img");
  frame2.className = "pack-photo";
  frame2.dataset.crop = product.crop || "original";
  img.src = `${window.OAT_ASSET_BASE}${product.image}`;
  img.alt = alt;
  frame2.append(img);
  return frame2;
}
function setFlavour(product, focus = false) {
  active = product;
  $$(".flavour-tab").forEach((tab) => {
    const selected = tab.dataset.flavour === product.id;
    tab.setAttribute("aria-selected", String(selected));
    tab.tabIndex = selected ? 0 : -1;
    if (selected && focus) tab.focus();
  });
  const panel = $("#flavour-panel");
  panel.style.setProperty("--flavour", product.color);
  panel.style.setProperty("--flavour-dark", product.dark);
  panel.style.setProperty("--flavour-paper", product.paper);
  panel.setAttribute("aria-labelledby", `tab-${product.id}`);
  text("[data-flavour-kind]", S.kind(product).toUpperCase());
  text("[data-flavour-name]", S.name(product).toUpperCase());
  text("[data-flavour-hook]", S.hook(product));
  text("[data-flavour-description]", S.description(product));
  text("[data-flavour-format]", S.format(product));
  const img = $("[data-flavour-image]");
  img.src = `${window.OAT_ASSET_BASE}${product.image}`;
  img.alt = S.packAlt(product);
  $("[data-featured-photo]").dataset.crop = product.crop || "original";
  $("[data-flavour-elements]").replaceChildren(...product.elements.map(ingredientFigure));
  track("flavour_viewed", { flavour: product.id });
}
$$(".flavour-tab").forEach((tab, index) => {
  tab.addEventListener("click", () => setFlavour(products[index]));
  tab.addEventListener("keydown", (event) => {
    let target;
    if (event.key === "ArrowRight") target = (index + 1) % products.length;
    if (event.key === "ArrowLeft") target = (index - 1 + products.length) % products.length;
    if (event.key === "Home") target = 0;
    if (event.key === "End") target = products.length - 1;
    if (target !== void 0) {
      event.preventDefault();
      setFlavour(products[target], true);
    }
  });
});
function confetti(milestone) {
  if (reduced.matches || document.body.classList.contains("motion-paused") || document.body.classList.contains("le-review-open")) return;
  const summary = $(".bundle-summary");
  summary.classList.remove("reward-flash");
  requestAnimationFrame(() => summary.classList.add("reward-flash"));
  const rect = summary.getBoundingClientRect();
  const x = rect.top < innerHeight && rect.bottom > 0 ? Math.min(innerWidth - 30, Math.max(30, rect.left + rect.width / 2)) : innerWidth / 2;
  const y = rect.top < innerHeight && rect.bottom > 0 ? Math.min(innerHeight - 80, Math.max(100, rect.top + 100)) : innerHeight * 0.55;
  const colours = ["#5CBB47", "#FBAE2E", "#745FAA", "#F7F3E9", "#191A18"];
  for (let i = 0; i < 34; i++) {
    const particle = document.createElement("i");
    particle.className = "confetti-piece";
    particle.style.cssText = `left:${x}px;top:${y}px;background:${colours[i % colours.length]};border-radius:${i % 3 === 0 ? "50%" : "1px"};--dx:${(Math.random() - 0.5) * 400}px;--dy:${100 + Math.random() * 320}px;--spin:${Math.random() * 700 - 350}deg`;
    document.body.append(particle);
    particle.addEventListener("animationend", () => particle.remove(), { once: true });
    setTimeout(() => particle.remove(), 2e3);
  }
  track("bundle_reward_unlocked", { milestone });
}
function updateBasket(announce = false, previous = totals(basket).count, quantityEvent = true) {
  const state = totals(basket);
  basket = state.basket;
  try {
    localStorage.setItem(storageKey, JSON.stringify(basket));
  } catch {
  }
  text("[data-basket-count],[data-total-count]", state.count);
  text("[data-pack-word]", S.packWord(state.count));
  const message = state.next ? S.nextMessage(state.next - state.count, state.next) : state.launch ? S.fullMessage : S.afterMessage;
  text("[data-unlock-message]", state.count ? message : S.startMessage);
  text("[data-retail]", money(state.retail));
  text("[data-savings]", `\u2212 ${money(state.savings)}`);
  text("[data-free-label]", S.freeLabel(state.free));
  const pay = payable(state);
  $("[data-sub-line]").hidden = !(buyType === "sub" && state.total > 0);
  text("[data-sub-savings]", `\u2212 ${money(state.total - pay)}`);
  text("[data-total-price],[data-dock-total]", money(pay));
  text("[data-delivery]", state.freeDelivery ? S.deliveryFree : S.deliveryLocked);
  text("[data-unit-price]", state.count ? S.unitPrice(money(Math.round(pay / state.count)), state.free || buyType === "sub") : S.unitStart);
  text("[data-dock-count]", S.dockCount(state.count));
  text("[data-dock-message]", S.dockMessage(state.free, state.next ? state.next - state.count : 0));
  const top = state.launch ? 7 : 4, fill = `${Math.min(1, state.count / top) * 100}%`;
  $("[data-progress-fill]").style.width = fill;
  $("[data-dock-progress]").style.width = fill;
  $(".reward-progress").setAttribute("aria-valuemax", top);
  $(".reward-progress").setAttribute("aria-valuenow", Math.min(state.count, top));
  $(".reward-progress").setAttribute("aria-valuetext", S.progressText(state.count, state.free));
  $$("[data-reward]").forEach((node) => node.classList.toggle("unlocked", state.count >= Number(node.dataset.reward)));
  $$("[data-quantity]").forEach((node) => {
    node.value = basket[node.dataset.quantity];
    node.textContent = basket[node.dataset.quantity];
  });
  $$("[data-delta]").forEach((button) => {
    button.disabled = Number(button.dataset.delta) > 0 ? state.count >= MAX_PACKS : basket[button.dataset.product] === 0;
  });
  $("[data-review-bundle]").disabled = !state.count;
  $("[data-clear-bundle]").disabled = !state.count;
  $("[data-add-featured]").disabled = state.count >= MAX_PACKS;
  $("[data-add-recipe]").disabled = state.count >= MAX_PACKS;
  const selected = products.flatMap((product) => Array.from({ length: basket[product.id] }, () => product));
  $$(".basket-slot").forEach((slot, index) => {
    slot.replaceChildren();
    slot.classList.toggle("free", index >= state.paid && index < state.count);
    const product = selected[index];
    if (product) slot.append(packPhoto(product, `${S.label(product)}${index >= state.paid ? S.slotFree : ""}`));
    else {
      slot.textContent = String(index + 1);
      slot.setAttribute("aria-label", S.slotEmpty(index + 1));
    }
    if (product) slot.removeAttribute("aria-label");
  });
  $("[data-bundle-dock]").hidden = !state.count;
  if (announce) {
    text("[data-bundle-status]", S.status(state.count, state.free, money(payable(state)), message));
    for (const milestone of state.launch ? [4, 7] : [4]) if (previous < milestone && state.count >= milestone) {
      confetti(milestone);
      toast(S.unlockToast(milestone));
    }
    if (quantityEvent) track("bundle_quantity_changed", { selected_quantity: state.count, free_quantity: state.free, selection_complete: state.count > 0, total_cents: payable(state), buy_type: buyType });
  }
}
function addProduct(id, delta = 1, notify = false) {
  const before = totals(basket).count;
  if (delta > 0 && before === MAX_PACKS) {
    toast(S.fullToast);
    return;
  }
  basket = changeQuantity(basket, id, delta);
  updateBasket(true, before);
  if (notify && ![4, 7].includes(totals(basket).count)) {
    const p = products.find((item) => item.id === id);
    toast(S.addedToast(p));
  }
}
$$("[data-delta]").forEach((button) => button.addEventListener("click", () => addProduct(button.dataset.product, Number(button.dataset.delta))));
$("[data-add-featured]").addEventListener("click", () => addProduct(active.id, 1, true));
$("[data-add-recipe]").addEventListener("click", () => {
  addProduct(recipe.id, 1, true);
  $("#recipe-dialog").close();
});
$$('input[name="buy-type"]').forEach((r) => {
  r.checked = r.value === buyType;
  r.addEventListener("change", () => {
    if (!r.checked) return;
    buyType = r.value;
    try {
      localStorage.setItem("oatmazing:buy-type", buyType);
    } catch {
    }
    updateBasket(true, void 0, false);
    track("buy_type_changed", { buy_type: buyType });
  });
});
var wasLive = offerLive();
var tickOffer = () => {
  const now = Date.now();
  if (!offerRemaining(now)) setOfferEnd(holdEndsAt(firstVisit, now));
  const left = offerRemaining(now), live = offerLive(now);
  $$("[data-offer-timer]").forEach((n) => {
    n.hidden = !left;
  });
  $$("[data-launch]").forEach((n) => {
    n.hidden = !live;
  });
  $$("[data-after-launch]").forEach((n) => {
    n.hidden = live;
  });
  if (live !== wasLive) {
    wasLive = live;
    updateBasket();
  }
  if (left) text("[data-countdown]", S.countdown(left));
};
tickOffer();
setInterval(tickOffer, 3e4);
$("[data-clear-bundle]").addEventListener("click", () => {
  const previous = totals(basket).count;
  basket = normaliseBasket(null);
  updateBasket(true, previous);
});
function openDialog(dialog) {
  lastFocus = document.activeElement;
  dialog.showModal();
  dialog.querySelector("button").focus();
}
function openRecipe(id) {
  recipe = products.find((product) => product.id === id) || active;
  text("#recipe-title", S.name(recipe));
  text("[data-recipe-kind]", S.kind(recipe).toUpperCase());
  text("[data-recipe-format]", S.recipeFormat(recipe));
  text("[data-recipe-note]", S.note(recipe));
  const img = $("[data-recipe-image]");
  img.src = `${window.OAT_ASSET_BASE}${recipe.image}`;
  img.alt = S.packAlt(recipe);
  $("[data-recipe-photo]").dataset.crop = recipe.crop || "original";
  $(".recipe-image").style.setProperty("--flavour-paper", recipe.paper);
  $("[data-recipe-ingredients]").replaceChildren(...S.ingredients(recipe).map((name, i) => {
    const li = document.createElement("li"), n = document.createElement("span");
    n.textContent = name;
    li.append(n);
    if (recipe.pct[i]) {
      const b = document.createElement("b");
      b.textContent = recipe.pct[i];
      li.append(b);
    }
    return li;
  }));
  openDialog($("#recipe-dialog"));
  track("recipe_opened", { flavour: recipe.id });
}
$$("[data-recipe]").forEach((button) => button.addEventListener("click", () => openRecipe(button.dataset.recipe)));
$("[data-open-featured]").addEventListener("click", () => openRecipe(active.id));
$$("[data-close-dialog]").forEach((button) => button.addEventListener("click", () => button.closest("dialog").close()));
$$("dialog").forEach((dialog) => {
  dialog.addEventListener("close", () => {
    if (lastFocus?.isConnected) lastFocus.focus();
  });
  dialog.addEventListener("keydown", (event) => {
    if (event.key !== "Tab") return;
    const focusable = [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex="0"]')].filter((element) => element.getClientRects().length);
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  dialog.addEventListener("click", (event) => {
    const r = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
  });
});
$("[data-review-bundle]").addEventListener("click", () => {
  const state = totals(basket);
  const lines = products.filter((product) => basket[product.id]).map((product) => {
    const row = document.createElement("div");
    row.className = "order-line";
    const img = packPhoto(product);
    const label = document.createElement("span"), name = document.createElement("strong"), kind = document.createElement("small"), qty = document.createElement("strong");
    name.textContent = S.name(product);
    kind.textContent = S.orderKind(product);
    qty.textContent = `\xD7 ${basket[product.id]}`;
    label.append(name, kind);
    row.append(img, label, qty);
    return row;
  });
  $("[data-order-lines]").replaceChildren(...lines);
  text("[data-order-total]", money(payable(state)));
  text("[data-order-delivery]", S.orderDelivery(state.free, buyType === "sub", SUBSCRIBE_PCT, state.freeDelivery));
  openDialog($("#order-dialog"));
  track("bundle_reviewed", { quantity: state.count, total_cents: payable(state), buy_type: buyType });
});
var frame = 0;
var clamp = (n) => Math.max(0, Math.min(1, n));
var ease = (t) => t * t * (3 - 2 * t);
var pourEl = $("[data-pour]");
var drops = $$(".pour-drop");
var steps = $$("[data-pour-step]");
var ripple = $(".pour-ripple");
var START = [[22, -14], [72, -10], [34, -18], [64, -14], [26, -10], [56, -18]];
var MOUTH = [47.5, 44];
var SPIN = [140, -24, 14, -14, 110, -30];
var landedBefore = -1;
function renderPour() {
  frame = 0;
  if (!pourEl) return;
  const r = pourEl.getBoundingClientRect(), sticky = pourEl.querySelector(".pour-sticky");
  document.body.classList.toggle("viewing-mix", r.top < innerHeight * 0.7 && r.bottom > innerHeight * 0.3);
  const still = reduced.matches || document.body.classList.contains("motion-paused") || document.body.classList.contains("le-review-open");
  const offset = parseFloat(getComputedStyle(sticky).top) || 0;
  const p = still ? 1 : clamp((offset - r.top) / Math.max(1, pourEl.offsetHeight - sticky.offsetHeight));
  const n = drops.length, span = 0.78 / n;
  let landed = 0;
  drops.forEach((d, i) => {
    const t = clamp((p - 0.05 - i * span) / (span * 1.6)), e = ease(t), [x0, y0] = START[i % START.length], shrink = clamp((t - 0.62) / 0.38);
    const x = x0 + (MOUTH[0] - x0) * e + Math.sin(t * Math.PI) * (i % 2 ? -6 : 6), y = y0 + (MOUTH[1] - y0) * e - Math.sin(t * Math.PI) * 4;
    d.style.transform = `translate(-50%,-50%) translate(${(x / 30 * 100).toFixed(1)}%,${(y / 30 * 100).toFixed(1)}%) rotate(${(t * SPIN[i % SPIN.length]).toFixed(0)}deg) scale(${(1 - 0.74 * shrink).toFixed(3)})`;
    d.style.opacity = t <= 0 ? "0" : String(clamp(t * 8) * (1 - clamp((t - 0.9) / 0.1)));
    if (t >= 1) landed++;
  });
  steps.forEach((li, i) => li.classList.toggle("is-in", i < landed));
  pourEl.classList.toggle("is-done", landed === n);
  if (landedBefore >= 0 && landed > landedBefore && ripple && !still) {
    ripple.classList.remove("splash");
    void ripple.offsetWidth;
    ripple.classList.add("splash");
  }
  landedBefore = landed;
}
var scheduleScroll = () => {
  if (!frame) frame = requestAnimationFrame(renderPour);
};
addEventListener("scroll", scheduleScroll, { passive: true });
addEventListener("resize", scheduleScroll);
reduced.addEventListener("change", scheduleScroll);
var note = $("[data-proposal-note]");
if (note) {
  const setNote = () => document.documentElement.style.setProperty("--note-h", note.offsetHeight + "px");
  setNote();
  if ("ResizeObserver" in window) new ResizeObserver(() => {
    setNote();
    scheduleScroll();
  }).observe(note);
}
$$("[data-recipe],[data-open-featured],.flavour-tab").forEach((button) => {
  button.disabled = false;
});
updateBasket();
scheduleScroll();
(() => {
  const reel = $("[data-reel]");
  if (!reel) return;
  const scenes = [...reel.querySelectorAll(".reel-scene")], bars = [...reel.querySelectorAll("[data-bar] i")], btn = reel.querySelector("[data-reel-toggle]");
  const HOLD = 4200;
  let i = 0, t0 = performance.now(), held = 0, hover = false, visible = true, userPaused = false;
  const show = (k) => {
    i = (k + scenes.length) % scenes.length;
    scenes.forEach((s, j) => {
      s.classList.toggle("is-on", j === i);
      s.setAttribute("aria-hidden", String(j !== i));
    });
    bars.forEach((b, j) => {
      b.style.transform = `scaleX(${j < i ? 1 : 0})`;
    });
    t0 = performance.now();
    held = 0;
    const nx = scenes[(i + 1) % scenes.length].querySelector("img");
    if (nx && nx.loading === "lazy") nx.loading = "eager";
  };
  const loop = (now) => {
    const run = !userPaused && !hover && visible && !document.hidden && !reduced.matches && !document.body.classList.contains("le-review-open");
    if (run) {
      const k = (now - t0) / HOLD;
      bars[i].style.transform = `scaleX(${Math.min(1, k).toFixed(3)})`;
      if (k >= 1) show(i + 1);
    } else t0 = now - held * HOLD;
    held = Math.min(1, (now - t0) / HOLD);
    requestAnimationFrame(loop);
  };
  reel.classList.add("is-live");
  show(0);
  requestAnimationFrame(loop);
  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    userPaused = !userPaused;
    btn.setAttribute("aria-pressed", String(userPaused));
    btn.setAttribute("aria-label", userPaused ? S.reelPlay : S.reelPause);
    reel.classList.toggle("is-paused", userPaused);
  });
  reel.addEventListener("click", (e) => {
    const r = reel.getBoundingClientRect();
    show(i + (e.clientX - r.left < r.width * 0.33 ? -1 : 1));
  });
  reel.addEventListener("pointerenter", (e) => {
    if (e.pointerType === "mouse") hover = true;
  });
  reel.addEventListener("pointerleave", () => {
    hover = false;
  });
  if ("IntersectionObserver" in window) new IntersectionObserver((es) => {
    visible = es[es.length - 1].isIntersecting;
  }).observe(reel);
})();
document.querySelectorAll(".ugc-card video").forEach((video) => video.addEventListener("play", () => document.querySelectorAll(".ugc-card video").forEach((other) => {
  if (other !== video) other.pause();
})));
(() => {
  const root = document.documentElement;
  const groups = [
    ["main section:not(#opening):not(.pour) .eyebrow", false],
    ["main section:not(#opening):not(.pour) h2", true],
    [".editorial-body>*", false],
    [".story-facts>*", false],
    [".ritual-card", false],
    [".ways-grid>li", false],
    [".how-steps>li", false],
    [".ugc-head>p", false],
    [".bundle-product", false],
    [".faq-list>details", false],
    [".closing h2", true],
    [".closing .button", false],
    [".trust-intro .rating-summary", false]
  ];
  const seen = /* @__PURE__ */ new Set(), targets = [];
  const onScreen = (el) => {
    const r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < innerHeight;
  };
  document.querySelectorAll("[data-pop-group]").forEach((g) => {
    if (onScreen(g)) g.querySelectorAll(".pop").forEach((n) => n.classList.remove("pop"));
  });
  for (const [sel, isHeading] of groups) [...document.querySelectorAll(sel)].forEach((el, idx, all) => {
    if (seen.has(el) || el.closest("[data-pop-group]") || onScreen(el)) return;
    seen.add(el);
    el.classList.add("rv");
    if (isHeading) el.classList.add("rv-h");
    const sibs = [...el.parentElement.children].filter((n) => n.matches(sel));
    el.style.setProperty("--i", String(Math.min(sibs.indexOf(el), 6)));
    targets.push(el);
  });
  if ("IntersectionObserver" in window) {
    root.classList.add("js-pop");
    const settle = (el) => setTimeout(() => {
      el.classList.remove("rv", "rv-h");
      el.querySelectorAll(".pop").forEach((n) => n.classList.remove("pop"));
    }, 1700 + (el.querySelectorAll(".pop").length || 1) * 90);
    const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-in");
      io.unobserve(entry.target);
      settle(entry.target);
      if (entry.target.matches(".rating-summary")) countUp(entry.target.querySelector("strong"));
    }), { threshold: 0.14, rootMargin: "0px 0px -6% 0px" });
    targets.forEach((el) => io.observe(el));
    document.querySelectorAll("[data-pop-group]").forEach((el) => io.observe(el));
  }
  function countUp(node) {
    if (!node || reduced.matches) return;
    const end = parseFloat(node.textContent);
    if (!(end > 0)) return;
    const t0 = performance.now(), d = 1100;
    const step = (now) => {
      const k = Math.min(1, (now - t0) / d), e = 1 - Math.pow(1 - k, 3);
      node.textContent = (end * e).toFixed(1);
      if (k < 1) requestAnimationFrame(step);
      else node.textContent = end.toFixed(1);
    };
    requestAnimationFrame(step);
  }
  const marquee = document.querySelector("[data-marquee]"), list = marquee && marquee.querySelector(".ugc-list");
  if (list && !reduced.matches) {
    const originals = [...list.children];
    originals.forEach((li, i) => {
      li.style.setProperty("--tilt", i % 2 ? "1.2deg" : "-1.6deg");
      li.style.setProperty("--drop", i % 2 ? "22px" : "0px");
    });
    originals.forEach((li) => {
      const copy = li.cloneNode(true);
      copy.setAttribute("aria-hidden", "true");
      copy.querySelectorAll("video").forEach((v) => v.setAttribute("tabindex", "-1"));
      list.appendChild(copy);
    });
    root.classList.add("js-marquee");
    const wrap = marquee.closest(".strip-wrap");
    let holdUntil = 0, last = 0, pos = 0;
    const half = () => (list.scrollWidth + (parseFloat(getComputedStyle(list).columnGap) || 18)) / 2;
    const hold = (ms) => {
      holdUntil = performance.now() + ms;
    };
    const still = () => marquee.matches(":hover") || marquee.contains(document.activeElement) || marquee.classList.contains("is-playing") || wrap && wrap.classList.contains("is-paused") || performance.now() < holdUntil || document.hidden;
    const drift = (now) => {
      const dt = Math.min(64, now - (last || now));
      last = now;
      if (still()) pos = marquee.scrollLeft;
      else {
        pos += dt * 0.05;
        if (pos >= half()) pos -= half();
        marquee.scrollLeft = pos;
      }
      requestAnimationFrame(drift);
    };
    requestAnimationFrame(drift);
    ["pointerdown", "touchstart", "wheel"].forEach((ev) => marquee.addEventListener(ev, () => hold(4e3), { passive: true }));
    marquee.addEventListener("scroll", () => {
      const h = half();
      if (marquee.scrollLeft >= h) marquee.scrollLeft -= h;
      else if (marquee.scrollLeft < 1 && performance.now() < holdUntil) marquee.scrollLeft += h;
    }, { passive: true });
    const sync = () => marquee.classList.toggle("is-playing", [...list.querySelectorAll("video")].some((v) => !v.paused && !v.ended));
    list.addEventListener("play", (event) => {
      list.querySelectorAll("video").forEach((v) => {
        if (v !== event.target) v.pause();
      });
      sync();
    }, true);
    list.addEventListener("pause", sync, true);
    list.addEventListener("ended", sync, true);
  }
  const ribbon = document.querySelector("[data-ribbon] .ribbon-track");
  if (ribbon) {
    if (!reduced.matches) {
      [...ribbon.children].forEach((n) => {
        const c = n.cloneNode(true);
        c.setAttribute("aria-hidden", "true");
        if (c.tagName === "A") c.setAttribute("tabindex", "-1");
        ribbon.appendChild(c);
      });
      root.classList.add("js-marquee");
    }
    ribbon.addEventListener("click", (e) => {
      const a = e.target.closest("[data-ribbon-flavour]");
      if (!a) return;
      const tab = document.getElementById("tab-" + a.dataset.ribbonFlavour);
      if (tab && !tab.disabled) {
        e.preventDefault();
        tab.click();
        document.getElementById("flavours").scrollIntoView({ behavior: reduced.matches ? "auto" : "smooth" });
      }
    });
  }
  if (root.classList.contains("js-marquee")) document.querySelectorAll("[data-strip-pause]").forEach((btn) => {
    btn.hidden = false;
    const wrap = btn.closest(".strip-wrap");
    btn.addEventListener("click", () => {
      const on = btn.getAttribute("aria-pressed") !== "true";
      btn.setAttribute("aria-pressed", String(on));
      btn.textContent = on ? S.play : S.pause;
      wrap.classList.toggle("is-paused", on);
    });
  });
  document.querySelectorAll("[data-slider-nav]").forEach((nav) => {
    const track2 = document.querySelector(nav.dataset.sliderNav);
    if (!track2) return;
    nav.addEventListener("click", (e) => {
      const b = e.target.closest("[data-dir]");
      if (!b) return;
      const card = track2.querySelector("li:not([aria-hidden])");
      const row = track2.matches(".ugc-marquee") ? track2.querySelector(".ugc-list") : track2;
      const gap = parseFloat(getComputedStyle(row).columnGap) || 16;
      const w = card ? card.getBoundingClientRect().width + gap : track2.clientWidth * 0.8;
      track2.dispatchEvent(new Event("pointerdown"));
      track2.scrollBy({ left: Number(b.dataset.dir) * w, behavior: reduced.matches ? "auto" : "smooth" });
    });
  });
  const finder = document.querySelector("[data-finder]");
  if (finder) {
    finder.hidden = false;
    const step2 = finder.querySelector('[data-step="2"]'), choices = finder.querySelector("[data-choices]"), out = finder.querySelector("[data-finder-result]");
    const OPTS = S.finder;
    finder.addEventListener("click", (e) => {
      const a = e.target.closest("[data-pick]");
      if (a) {
        finder.querySelectorAll("[data-pick]").forEach((x) => x.setAttribute("aria-pressed", String(x === a)));
        choices.replaceChildren(...OPTS[a.dataset.pick].map(([id, label]) => {
          const x = document.createElement("button");
          x.type = "button";
          x.dataset.flavourPick = id;
          x.textContent = label;
          return x;
        }));
        step2.hidden = false;
        out.textContent = "";
        return;
      }
      const f = e.target.closest("[data-flavour-pick]");
      if (!f) return;
      const pr = products.find((x) => x.id === f.dataset.flavourPick);
      const tab = document.getElementById("tab-" + pr.id);
      if (tab && !tab.disabled) tab.click();
      out.textContent = S.finderResult(pr);
      track("flavour_finder", { flavour: pr.id });
      document.getElementById("flavour-panel").scrollIntoView({ behavior: reduced.matches ? "auto" : "smooth", block: "center" });
    });
  }
  if (matchMedia("(hover:hover) and (pointer:fine)").matches && !reduced.matches) document.querySelectorAll(".ritual-card").forEach((card) => {
    card.addEventListener("pointermove", (e) => {
      const r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = `perspective(900px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg) translateY(-4px)`;
    });
    card.addEventListener("pointerleave", () => {
      card.style.transform = "";
    });
  });
  const buy = document.querySelector("[data-mobile-buy]"), hero = document.querySelector("#opening"), builder = document.querySelector("#bundle"), dock = document.querySelector("[data-bundle-dock]");
  if (buy && hero && builder && "IntersectionObserver" in window) {
    const state = { hero: true, builder: false };
    const update = () => {
      buy.hidden = state.hero || state.builder || dock && !dock.hidden;
    };
    new IntersectionObserver((es) => {
      state.hero = es[es.length - 1].isIntersecting;
      update();
    }).observe(hero);
    new IntersectionObserver((es) => {
      state.builder = es[es.length - 1].isIntersecting;
      update();
    }, { threshold: 0.05 }).observe(builder);
    if (dock) new MutationObserver(update).observe(dock, { attributes: true, attributeFilter: ["hidden"] });
  }
  const bar = document.createElement("div");
  bar.className = "scroll-progress";
  bar.setAttribute("aria-hidden", "true");
  document.body.appendChild(bar);
  let tick = 0;
  addEventListener("scroll", () => {
    if (tick) return;
    tick = requestAnimationFrame(() => {
      tick = 0;
      const h = document.documentElement.scrollHeight - innerHeight;
      bar.style.transform = `scaleX(${h > 0 ? Math.min(1, scrollY / h) : 0})`;
    });
  }, { passive: true });
})();
